// /* eslint jsx-a11y/no-noninteractive-element-to-interactive-role: 0 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
// import ReactDom from 'react-dom';
import classnames from 'classnames';
import type { RCSelectProps } from './iRCTimePicker';
// import PropTypes from 'prop-types';

const scrollTo = (element: HTMLElement, to: number, duration: number) => {
    const requestAnimationFrame =
        window.requestAnimationFrame ||
        function requestAnimationFrameTimeout() {
            return setTimeout(arguments[0], 10); // eslint-disable-line
        };
    // jump to target if duration zero
    if (duration <= 0) {
        element.scrollTop = to;
        return;
    }
    const difference = to - element.scrollTop;
    const perTick = (difference / duration) * 10;

    requestAnimationFrame(() => {
        element.scrollTop += perTick;
        if (element.scrollTop === to) return;
        scrollTo(element, to, duration - 10);
    });
};

const Select: React.FC<RCSelectProps> = (props) => {
    const {
        prefixCls,
        options,
        selectedIndex,
        width,
        type,
        onSelect
    } = props;

    const [active, setActive] = useState(false);
    const listRef = useRef<HTMLUListElement>(null);
    const listBoxRef = useRef<HTMLDivElement>(null);

    const scrollToSelected = useCallback((duration: number) => {
        // move to selected item
        const select = listBoxRef.current;
        const list = listRef.current;
        if (!list || !select) {
            return;
        }
        let index = selectedIndex;
        if (index < 0) {
            index = 0;
        }
        const topOption = list.children[index];
        const to = (topOption as HTMLElement).offsetTop;
        scrollTo(select, to, duration);
    }, [selectedIndex]);

    useEffect(() => {
        // jump to selected option
        scrollToSelected(0);
    }, []); // eslint-disable-line

    useEffect(() => {
        // smooth scroll to selected option
        scrollToSelected(120);
    }, [selectedIndex, scrollToSelected]);

    const handleSelect = useCallback((value: string) => {
        onSelect(type, value);
    }, [onSelect, type]);

    const getOptions = useCallback(() => {
        return options.map((item, index) => {
            const cls = classnames({
                [`${prefixCls}-select-option-selected`]: selectedIndex === index,
                [`${prefixCls}-select-option-disabled`]: item.disabled
            });
            const onClick = item.disabled
                ? undefined
                : () => {
                    handleSelect(item.value);
                };
            return (
                <li role='button' onClick={onClick} className={cls} key={index}>
                    {item.value}
                </li>
            );
        });
    }, [options, selectedIndex, prefixCls, handleSelect]);

    const handleMouseEnter = useCallback(() => {
        setActive(true);
    }, []);

    const handleMouseLeave = useCallback(() => {
        setActive(false);
    }, []);

    if (options.length === 0) {
        return null;
    }
    const cls = classnames(`${prefixCls}-select`, {
        [`${prefixCls}-select-active`]: active
    });
    return (
        <div
            className={cls}
            style={{width: width}} // Input的宽度传给选项的容器div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={listBoxRef}
        >
            <ul ref={listRef}>{getOptions()}</ul>
        </div>
    );
};

export default Select;